import {
  Stack,
  IconButton,
  Typography,
  MenuItem,
  Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { SearchBar } from 'src/components/search-bar';

export default function CandidateToolbar({
  handleSearchCandidate,
  setShowFiltersBar,
  filters,
  SORT_MAP,
  sortBy,
  setSortBy,
  isShowingFilterResult,
  showFiltersBar,
  resetCheckedCandidates,
  totalCandidates,
}) {
  const sortPopover = usePopover();

  return (
    <Stack
      mb="16px"
      alignItems="center"
      justifyContent="space-between"
      direction="row"
    >
      <SearchBar
        placeholder={`Search from ${totalCandidates} talents`}
        // onClick={() => resetCheckedCandidates()}
        onChange={handleSearchCandidate}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSearchCandidate(e);
          }
        }}
      />

      <Stack alignItems="center" spacing="8px" direction="row">
        <Tooltip title={filters ? '' : 'No candidates found'}>
          <IconButton
            variant="outlined"
            sx={{
              borderColor: theme => showFiltersBar && theme.palette.info.main,
            }}
            onClick={() => {
              //   resetCheckedCandidates();
              setShowFiltersBar(prev => !prev);
            }}
          >
            <Iconify icon="tabler:adjustments-horizontal" />
          </IconButton>
        </Tooltip>

        {/* <IconButton
          sx={{
            borderColor: theme =>
              (sortPopover.open ||
                SORT_MAP[sortBy].value !== SORT_MAP.NONE.value) &&
              theme.palette.info.main,
            width:
              SORT_MAP[sortBy].value === SORT_MAP.NONE.value ? 'auto' : '100px',
          }}
          onClick={sortPopover.onOpen}
          variant="outlined"
        >
          <Stack direction="row" alignItems="center" spacing="8px">
            <Iconify
              icon={`tabler:${
                SORT_MAP[sortBy].value === SORT_MAP.NONE.value
                  ? 'arrows-sort'
                  : `arrow-${SORT_MAP[sortBy].arrow}`
              }`}
            />

            {SORT_MAP[sortBy].value !== SORT_MAP.NONE.value && (
              <Typography variant="input">{SORT_MAP[sortBy].label}</Typography>
            )}
          </Stack>
        </IconButton> */}
      </Stack>

      <CustomPopover open={sortPopover.open} onClose={sortPopover.onClose}>
        <Typography
          variant="paragraph"
          fontWeight={600}
          sx={{
            mb: '12px',
          }}
        >
          Sort By
        </Typography>
        {Object.keys(SORT_MAP).map(item => {
          if (
            SORT_MAP[sortBy].value === SORT_MAP.NONE.value &&
            SORT_MAP[item].value === SORT_MAP.NONE.value
          )
            return null;
          return (
            <MenuItem
              key={item}
              onClick={() => {
                setSortBy(item);
                sortPopover.onClose();
              }}
            >
              <Typography variant="input">{SORT_MAP[item].label}</Typography>
            </MenuItem>
          );
        })}
      </CustomPopover>
    </Stack>
  );
}

CandidateToolbar.propTypes = {
  handleSearchCandidate: PropTypes.func,
  setShowFiltersBar: PropTypes.func,
  filters: PropTypes.object,
  SORT_MAP: PropTypes.object,
  sortBy: PropTypes.string,
  setSortBy: PropTypes.func,
  isShowingFilterResult: PropTypes.bool,
  showFiltersBar: PropTypes.bool,
  resetCheckedCandidates: PropTypes.func,
  totalCandidates: PropTypes.number,
};
